import convert from 'color-convert';

import { moodColors } from '../styles';

export const getColor = (value: number) => {
  //value from 0 to 1
  value = 1 - value;
  const hue = (value * 160 + 200).toString(10);
  const trans = convert.hsl.rgb([parseInt(hue), 80, 50]);
  return `rgba(${trans[0]},${trans[1]},${trans[2]},1)`;
};

export const setColor = (value: number) => {
  switch (true) {
    case value > 0 && value <= 0.333: // TODO: Move these hardcoded values to global constants.
      return moodColors.negative;
    case value <= 0.666:
      return moodColors.neutral;
    case value <= 1:
      return moodColors.positive;
    default:
      return '#fff';
  }
};

export const getMoodName = (value: number) => {
  switch (true) {
    case value > 0 && value <= 0.333: // TODO: Move these hardcoded values to global constants.
      return 'Negative';
    case value <= 0.666:
      return 'Balanced';
    case value <= 1:
      return 'Positive';
    default:
      return 'Balanced';
  }
};
